import { IdToken } from "@auth0/auth0-react"

export enum EFunctionalityOverrides {
    AUTH = "AUTH",
    GPS = "GPS",
}

export enum ENativeLayerOutgoingEventType {
    REQUEST_NATIVE_SYNC = "REQUEST_NATIVE_SYNC",
    LOGOUT = "LOGOUT",
    SET_TENANT = "SET_TENANT",
    SET_SHIFT = "SET_SHIFT",
    SET_VEHICLE = "SET_VEHICLE",
}

interface NativeLayerOutgoingLogoutEvent {
    type: ENativeLayerOutgoingEventType.LOGOUT
}

interface NativeLayerOutgoingSetTenantEvent {
    type: ENativeLayerOutgoingEventType.SET_TENANT
    tenantId: string
}

interface NativeLayerOutgoingSetShiftEvent {
    type: ENativeLayerOutgoingEventType.SET_SHIFT
    shiftId: string
}

interface NativeLayerOutgoingSetVehicleEvent {
    type: ENativeLayerOutgoingEventType.SET_VEHICLE
    vehicleId: string
}

interface NativeLayerOutgoingRequestNativeSyncEvent {
    type: ENativeLayerOutgoingEventType.REQUEST_NATIVE_SYNC
}

export type NativeLayerOutgoingEvent =
    | NativeLayerOutgoingLogoutEvent
    | NativeLayerOutgoingSetTenantEvent
    | NativeLayerOutgoingSetShiftEvent
    | NativeLayerOutgoingSetVehicleEvent
    | NativeLayerOutgoingRequestNativeSyncEvent

// --------------- CONTEXT TYPES ---------------
export type CurrentGPSCoordinates = [number, number] //Stored in accordance to GeoJSON [long, lat]

// --------------- EVENT TYPES ---------------

export enum ENativeLayerIncomingEventType {
    SET_ID_TOKEN = "SET_ID_TOKEN",
    SET_GPS = "SET_GPS",
    SET_FUNCTIONALITY_OVERRIDES = "SET_FUNCTIONALITY_OVERRIDES",
}

interface NativeLayerIncomingSetIdTokenEvent {
    type: ENativeLayerIncomingEventType.SET_ID_TOKEN
    auth0IdToken: IdToken
}

interface NativeLayerIncomingSetGPSEvent {
    type: ENativeLayerIncomingEventType.SET_GPS
    currentGPSCoordinates: CurrentGPSCoordinates
}

interface NativeLayerIncomingSetFunctionalityOverridesEvent {
    type: ENativeLayerIncomingEventType.SET_FUNCTIONALITY_OVERRIDES
    nativeFunctionalityOverrides: EFunctionalityOverrides[]
}

export type NativeLayerIncomingEvent =
    | NativeLayerIncomingSetIdTokenEvent
    | NativeLayerIncomingSetGPSEvent
    | NativeLayerIncomingSetFunctionalityOverridesEvent
